import React from "react";
import { Star } from "lucide-react";

// Shows a partner's average rating + review count, or a "New" pill when they have no reviews yet.
export function RatingBadge({ rating, count = 0, size = "sm", testid }) {
  const isNew = !count || !rating;
  const starClass = size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5";
  if (isNew) {
    return (
      <span
        data-testid={testid}
        className="inline-flex items-center gap-1 rounded-full bg-[#EAF2EC] text-[#3F6B4E] px-2.5 py-0.5 text-xs font-medium"
        title="New partner — no reviews yet"
      >
        New partner
      </span>
    );
  }
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1 rounded-full bg-[#F3E7EA] text-[#8A4A58] px-2.5 py-0.5 text-xs font-medium"
      title={`${rating} average from ${count} review${count === 1 ? "" : "s"}`}
    >
      <Star className={`${starClass} fill-[#C77F8C] text-[#C77F8C]`} />
      <b>{rating}</b>
      <span className="opacity-70">({count})</span>
    </span>
  );
}
